export const formatPathname = (rawPathname: string) => {
  return rawPathname.split('?')[0].toLowerCase() // grab everything before any ?lang=es-mx or any other params
}
